import { ActiveModelSerializer } from 'active-model-adapter';

export default ActiveModelSerializer.extend({
  isNewSerializerAPI: true,

  normalize(type, hash, prop) {
    // TODO: Delete this file when the ui_api is updated to do this
    hash.id = hash.action_type;
    delete hash.action_type;

    return this._super(type, hash, prop);
  },
});
